<template>
    <div>
        <h1 class="subtitle">Carga Masiva de ordenes de Servicio</h1>
        <b-field class="file">
            <b-upload v-model="file">
                <a class="button is-primary">
                    <b-icon icon="upload"></b-icon>
                    <span>Click to upload</span>
                </a>
            </b-upload>
            <span class="file-name" v-if="file">
                {{ file.name }}
            </span>
        </b-field>
        <button class="button is-success" @click="uploadFile" :disabled="!file">
            Cargar archivo
        </button>
    </div>
</template>

<script>
import axios from "axios"
import { mapGetters } from "vuex"
export default {
    name: "OrdenMassive",
    data() {
        return {
            file: null,
        }
    },
    computed: {
        usuario() {
            return UsuarioService.getUsuario()
        },
    },
    methods: {
        uploadFile() {
            let form = new FormData()
            form.append("file", this.file)
            form.append(
                "usuario",
                this.usuario.usu_id
            )
            axios.post("/orden/massive", form).then(
                response => {
                    this.$buefy.toast.open({
                        duration: 5000,
                        message: `Se cargo ${response.data.length} ordenes`,
                        position: "is-bottom",
                        type: "is-success"
                    })
                }
            ).catch(
                error => {
                    this.$buefy.toast.open({
                        duration: 5000,
                        message: error.response.data.message,
                        position: "is-bottom",
                        type: "is-danger"
                    })
                }
            )
        }
    }
}
</script>

<style scoped></style>
